export default __webpack_public_path__ + "static/media/sgb.831f535d.webp";